import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { useGetDetailRequests } from "../hooks/get-detail-request";
import { Skeleton } from "antd";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { DETAIL, DETAIL2 } from "../constant/field-names";
import { Row, Col } from "antd";

export const Information: FC = () => {
  const { data, isLoading } = useGetDetailRequests();
  if (isLoading) return <Skeleton />;

  return (
    <div>
      <Box title="Thông tin phiếu đăng ký sử dụng phòng họp">
        <Row gutter={[32, 0]}>
          {DETAIL.map((value) => {
            return (
              <Col span={value.span}>
                <Row gutter={[32, 0]}>
                  <Col span={12}>{value.label}</Col>
                  <Col span={12} className="font-weight-bold">
                    {data.fields?.[value.field]}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Box>

      <Box title="Thông tin chi tiết">
        <Row gutter={[32, 12]}>
          {DETAIL2.map((value) => {

            if (value.field === "eMeetingTime")
              return (
                <Col span={value.span}>
                  <Row gutter={[32, 0]}>
                    <Col span={12}>{value.label}</Col>
                    <Col span={12} className="font-weight-bold">
                      {getHHmmFormat(data.fields?.[value.field]) +
                        " - " +
                        getDDMMYYYFormat(data.fields?.[value.field])}
                    </Col>
                  </Row>
                </Col>
              );

            return (
              <Col span={value.span}>
                <Row gutter={[32, 0]}>
                  <Col span={12}>{value.label}</Col>
                  <Col span={12} className="font-weight-bold">
                    {data.fields?.[value.field]}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Box>
    </div>
  );
};
